import axios from "axios";
import {SPECCHECK_API_URL} from "@/common/config";

function init() {
    return axios.create({
        baseURL: SPECCHECK_API_URL,
    });
}

const Api = {
    get(resource, params = null) {
        return init().get(resource, params)
    },
};

export default Api;